export const cols = [{
	prop: 'pname',
	label: '商品名称',
	width: '',
	ischoose: true,
	sortable: false,
	align: 'center'
}, {
	prop: 'spec',
	label: '规格',
	width: '',
	ischoose: true,
	sortable: false,
	align: 'center'
}]
